// Uses its own localStorage key (distinct from the platform-wide `i18nextLng`
// key that useLanguageInitialization watches) so picking an offer language
// never triggers a platform UI language switch.
export const OFFER_LANG_STORAGE_KEY = 'offerLang';

export const resolveOfferLang = (): string =>
  window.localStorage.getItem(OFFER_LANG_STORAGE_KEY)
  || 'en-us';
